module.exports = __webpack_public_path__ + "static/media/ctv_homedecoratingchannel_video.a6b4c996.png";